<template>
    <div class="hero-section">
      <div class="hero-content">
        <h1 class="title-results">Resultados</h1>
        <p class="description-Results text-center">
            Padres que entienden mejor a sus hijos, hijos que recuperan la motivación, 
            y decisiones de carrera que evitan gastos innecesarios y cuidan la economía familiar
        </p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ContactUsSection'
}
</script>

<style scoped>
.hero-section {
  width: 100%;
  height: 700px;
  background: url('../../assets/img/DTS_The_Internet_Fanette_Guilloud_Photos_ID5236.jpg') no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.hero-content {
  display: flex;
  max-height: 1400px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
}

/* SOLO adaptación móvil, sin afectar web */
@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 320px;
    padding: 16px 0;
  }
  .hero-content {
    gap: 16px;
    max-width: 100%;
    padding: 0 4vw;
  }
  .title-results {
    font-size: 1.3rem;
    margin-bottom: 6px;
    word-break: break-word;
  }
  .description-Results {
    font-size: 1rem;
    margin-bottom: 10px;
    max-width: 100%;
    padding: 0 2vw;
    word-break: break-word;
  }
}
</style>
